import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';
import { Link } from 'react-router-dom';


const Banner = () => {
    return (
        <Stack className="banner">
            <Container>
                <Row>
                    <Col sm="6" md="7">
                        <h1 className="headingone">
                        Boost Your <span>Development </span>
                        with Premier <span>Offshore </span>
                        Certified Talents
                        </h1>
                        <p>Save Up to 36% on Costs and Achieve 100% Quality
                            with Our Standardized Project 
                            Management Tools and Techniques.
                        </p>
                        <Link to="/about" className="default-btn-style border-0 text-white">
                            About Us
                        </Link>
                    </Col>
                    <Col sm="6" md="5">
                        <Image src="/images/img_carriere 1.png" />
                    </Col>
                </Row>
            </Container>
        </Stack>
    )
}


export default Banner;